import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatDateWarehouse } from "../../../utils/Format/formatDateWarehouse";

const getMaintenanceColor = (date?: string | null, daysBefore = 30) => {
  if (!date) return null;
  const days = Math.ceil((new Date(date).getTime() - Date.now()) / 86400000);
  if (days < 0) return "error" as const;
  if (days <= daysBefore) return "warning" as const;
  return "default" as const;
};

interface MaintenanceChipProps {
  date?: string | null;
  daysBefore?: number;
}

export default function MaintenanceChip({ date, daysBefore }: Readonly<MaintenanceChipProps>) {
  const { i18n } = useTranslation();
  const color = getMaintenanceColor(date, daysBefore ?? 30);
  if (!date || !color) return <>-</>;

  return <Chip size="small" variant="outlined" color={color} label={formatDateWarehouse(date, i18n.language)} />;
}